var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-0",attrs:{"min-width":"0","text":"","to":"/app/reference/contact","exact":""}},[_c('v-icon',[_vm._v("mdi-phone-message-outline")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }